exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.custom-checkclient[data-v-c5d4454e] {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tpadding: 0px 16px;\n}\n.custom-checkclient input[data-v-c5d4454e] {\n\twidth: 10%;\n\theight: 25px;\n}\n\n", ""]);

// exports
